//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import { mapGetters } from 'vuex'
export default {
  name: 'exercicio',
  data: () => {
    return {
      buttons: [],
      tipos: ['sanguineo', 'colerico', 'melancolico', 'fleugmatico'],
      melancolico: [
        'Animado',
        'Brincalhão',
        'Sociável',
        'Convincente',
        'Refrescante',
        'Espirituoso',
        'Estimulador',
        'Espontâneo',
        'Otimista',
        'Engraçado',
        'Encantador',
        'Alegre',
        'Inspirado',
        'Demonstrativo',
        'Desembaraçado',
        'Conversador',
        'Vivo',
        'Atraente',
        'Popular',
        'Vivaz',
        'Metido',
        'Indisciplinado',
        'Repetitivo',
        'Esquecido',
        'Inoportuno',
        'Imprevisível',
        'Casual',
        'Permissivo',
        'Esquentado',
        'Ingênuo',
        'Egoísta',
        'Tagarela',
        'Desorganizado',
        'Inconstante',
        'Desordenado',
        'Convencido',
        'Barulhento',
        'Distraído',
        'Agitado',
        'Instável'
      ],
      fleugmatico: [
        'Aventureiro',
        'Persuasivo',
        'Enérgico',
        'Competitivo',
        'Habilidoso',
        'Auto-suficiente',
        'Positivo',
        'Seguro',
        'Franco',
        'Vigoroso',
        'Audacioso',
        'Confiante',
        'Independente',
        'Decidido',
        'Ativo',
        'Tenaz',
        'Líder',
        'Chefe',
        'Produtivo',
        'Valente',
        'Mandão',
        'Insensível',
        'Inflexível',
        'Franco',
        'Impaciente',
        'Frio',
        'Cabeçudo',
        'Orgulhoso',
        'Combativo',
        'Corajoso',
        'Workaholic',
        'Indelicado',
        'Imperioso',
        'Intolerante',
        'Manipulador',
        'Obstinado',
        'Tirânico',
        'Irritável',
        'Imprudente',
        'Astuto'
      ],
      sanguineo: [
        'Analítico',
        'Persistente',
        'Abnegado',
        'Atencioso',
        'Respeitoso',
        'Sensível',
        'Planejador',
        'Organizado',
        'Ordeiro',
        'Fiel',
        'Minucioso',
        'Culto',
        'Idealista',
        'Profundo',
        'Musical',
        'Pensativo',
        'Leal',
        'Detalhista',
        'Perfeccionista',
        'Comportado',
        'Acanhado',
        'Rancoroso',
        'Ressentido',
        'Complicado',
        'Inseguro',
        'Impopular',
        'Insatisfeito',
        'Pessimista',
        'Alienado',
        'Negativo',
        'Retraído',
        'Tímido',
        'Deprimido',
        'Introvertido',
        'Triste',
        'Cético',
        'Solitário',
        'Desconfiado',
        'Vingativo',
        'Crítico'
      ],
      colerico: [
        'Adaptável',
        'Sereno',
        'Submisso',
        'Controlado',
        'Reservado',
        'Satisfeito',
        'Paciente',
        'Tímido',
        'Serviçal',
        'Amigável',
        'Diplomático',
        'Consistente',
        'Inofensivo',
        'Irônico',
        'Mediador',
        'Tolerante',
        'Ouvinte',
        'Contente',
        'Agradável',
        'Equilibrado',
        'Vazio',
        'Desinteressado',
        'Relutante',
        'Medroso',
        'Indeciso',
        'Desligado',
        'Hesitante',
        'Simples',
        'Incerto',
        'Indiferente',
        'Preocupado',
        'Sensível demais',
        'Confuso',
        'Apático',
        'Resmungão',
        'Lento',
        'Preguiçoso',
        'Vagaroso',
        'Relutante',
        'Acomodado'
      ],
      i: 0,
      resultado: [0, 0, 0, 0],
      loading: false
    }
  },
  methods: {
    returnTipo (j) {
      return this.definicoesPalavras[this.i - 1]
    },
    imprimeResposta (button, j) {
      let tipos = this.returnTipo(j)
      for (let k = 0; k < tipos.length; k++) {
        if (button.rodada === tipos[k].tipo) {
          return tipos[k].texto
        }
      }
    },
    captura (button) {
      if (this.i === 40) {
        this.loading = true
        setTimeout(() => {
          this.$store.commit('resultado', this.resultado)
          this.$router.push('/relatorio')
        }, 2000)
      }
      switch (button.tipo) {
        case 'melancolico':
          this.resultado[2] += 1
          break
        case 'fleugmatico':
          this.resultado[3] += 1
          break
        case 'sanguineo':
          this.resultado[0] += 1
          break
        case 'colerico':
          this.resultado[1] += 1
          break
      }
      this.displayItems()
    },
    displayItems () {
      let id = 1
      this.buttons = []
      for (let r = 0; r < this.rodada.length; r++) {
        let button = {
          id: id,
          rodada: this.rodada[r],
          tipo: this.tipos[r]
        }

        this.buttons.push(button)
        id++
      }
      this.shuffle(this.buttons)
    },
    shuffle (array) {
      let currentIndex = array.length
      let temporaryValue
      let randomIndex

      while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1

        temporaryValue = array[currentIndex]
        array[currentIndex] = array[randomIndex]
        array[randomIndex] = temporaryValue
      }

      this.i += 1
      Vue.set(this.buttons, currentIndex, this.buttons[randomIndex])
      Vue.set(this.buttons, randomIndex, temporaryValue)
    }
  },
  computed: {
    rodada () {
      return [
        this.melancolico[this.i],
        this.fleugmatico[this.i],
        this.sanguineo[this.i],
        this.colerico[this.i]
      ]
    },
    ...mapGetters([
      'definicoesPalavras'
    ])
  },
  created () {
    this.displayItems()
    this.$store.commit('formulario', JSON.parse(localStorage['formulario']))
  }
}
